<template>
    <templateList
        hide-filters
        page-name="Lista de Usuários Bloqueados"
        search-input-placeholder="Buscar Usuário"
        add-button-text="Adicionar Usuário"
        add-event="users-inactives-add"
        search-event="users-inactives-search"
        filters-apply-event="filter-list-inactives-users"
        clear-filters-event="clear-list-inactives-users"
        :has-add-button="false"
        menu-card-icon="fal fa-cog"
    >
        <template #bradcrumbs>
            <ui-breadcrumbs design="full" :container="false">
                <template #left> Usuários &#8226; Lista de Usuários Bloqueados </template>
            </ui-breadcrumbs>
        </template>

		<template #viewOptions>
            <div v-if="checkedItens > 0" class="selected-inactives">
                <span  class="selected-inactives-text">
                    Você selecionou <span class="selected-inactives-count">{{ checkedItens }}</span> usuários inativos.
                </span>
				<div class="select-container">
					<ui-select-v2
						:data="selectMassAction"
						return-value="value"
						:placeholder="'Selecione uma ação'"
						:search="false"
						:showFooter="false"
						size="lg"
						@input="handleMassAction"
						v-model="value"
						:margin-botton="false"
					/>
				</div>
            </div>
        </template>

        <template #content>
            <ui-data-table
                :per-page="50"
                :columns="tableColumns"
                :sort-by="{ value: 'activation_code', dir: 'desc' }"
                :control-fixed="true"
                :is-fixed-list="true"
                :borders="true"
                :zebra="true"
				:showCheckboxTable="true"
                name="users-list"
                service="usersInactives"
                search-event="users-inactives-search"
                tr-component="users/inactives/table-line"
                not-found-icon="fal fa-user"
                not-found-text="Não foi possível encontrar nenhum Usuário"
				@checked-itens="handleCheckedItens"
            />

            <ui-modal-message
                name="change-user-status" 
                :title="modal.title" 
                :text="modal.text" 
                service="user" 
                btn-type="danger" 
                btn-text="Confirmar"
                icon="fal fa-trash-alt"
                color-circle="danger"
                icon-circle 
			/>

			<ui-modal-message-v2
				name="mass-change-user-status"
				service="user" 
				:cancelButton="cancelButtonHandle"
				:color-square="colorSquare"
				icon-square
				dynamicIcon="ui-user-lock-icon"
				@close-modal="clearSelect"
			>
				<template #title>
					<div v-if="!responseError">
						{{ modalTitle }}
					</div>
					<div v-if="responseError">
						{{ modalTitle }} <span class="interrupted-text">interrompido.</span>
					</div>
				</template>
				<template #text>
					<div v-if="!loadingBulkChange && !success && !responseError">
						Tem certeza que deseja {{ modalAction }} <span class="bulk-change-modal-text">{{ modalText }}</span> selecionados?
					</div>
					<div v-if="loadingBulkChange && !success && !responseError" class="loading-text">
						<ui-load-indicator
							v-if="loadingBulkChange && !success && !responseError"
							:h="24"
							:stroke="8"
							bg-color="#D9DFF1"
							color="#0091FF"
						/>
						<span>Espere alguns segundos, estamos finalizando.</span>
					</div>
					<div v-if="!loadingBulkChange && success && !responseError" class="successful-text">
						<ui-checked-icon/>
						<span>Usuários {{ modalActionExecuted }} com sucesso.</span>
					</div>
					<div v-if="!loadingBulkChange && !success && responseError">
						{{ modalErrorText }}
					</div>
				</template>
				<template #footer>
					<div v-if="!loadingBulkChange && !success && !responseError">
						<ui-button :design="'md success'" @click="bulkStatusChangeAction"> {{ modalButtonText }} </ui-button>
					</div>
					<div v-if="loadingBulkChange && !success && !responseError"><ui-button :design="'md primary'" :disabled="true" @click="closeModal()"> Sair </ui-button></div>
					<div v-if="!loadingBulkChange && success && !responseError"><ui-button :design="'md primary'" @click="closeModal()"> Sair </ui-button></div>
					<div v-if="!loadingBulkChange && !success && responseError" class="interrupted-footer">
						<div class="suport-text">
							<ui-suport-icon/>
							<p>Se o erro persistir, entre em <span class="support-contact">contato com o suporte.</span></p>
						</div>
						<ui-button :design="'md primary'" @click="closeModal()"> Sair </ui-button>
					</div>
				</template>
			</ui-modal-message-v2>
        </template>
    </templateList>
</template>

<script>
	import { uiBreadcrumbs, uiDataTable, uiLoadIndicator  } from '@/components/ui'
	import { uiSelectV2 } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'
	import { uiModalMessage, uiModalMessageV2 } from '@/components/ui/modal'
	import templateList from '@/templates/page-list'

	import helpers from '@/mixins/helpers'
	import { user } from '@/services/axios'

	const defaultModal = {
		text: 'O usuário(a) não poderá mais acessar o sistema e o aplicativo.',
		title: 'Deseja realmente bloquear este usuário(a)?'
	}

	export default {
		name: 'ui-list-inactives',
		components: {
			templateList,
			uiBreadcrumbs,
			uiDataTable,
			uiModalMessage,
			uiModalMessageV2,
			uiSelectV2,
			uiButton,
			uiLoadIndicator
		},
		mixins: [helpers],
		data() {
			return {
				modal: { ...defaultModal },
				tableColumns: [
					{
						title: 'Nome do Usuário',
						sortable: true,
						data: 'first_name',
					},
					{
						title: 'E-mail',
						sortable: true,
						data: 'email',
					},
					{
						title: 'Pontos',
						sortable: false,
						data: 'value',
					},
					{
						title: 'Atualização',
						sortable: true,
						data: 'updated_at',
					},
					{
						title: '',
					},
				],
				checkedItens: 0,
				selectMassAction: [
					{
						label: 'Desbloquear usuários',
						value: 'active'
					}
				],
				value: null,
				colorSquare: 'primary',
				modalButtonText: '',
				success: false,
				loadingBulkChange: false,
				cancelButtonHandle: true,
				modalTitle: '',
				modalAction: '',
				modalActionExecuted: '',
				modalText: '',
				responseError: false,
				modalErrorText: ''
			}
		},

		computed: {},

		mounted() {
			this.$root.$on('open-change-inactives-status-modal', (data) => {
				this.modal = data.modal

				this.$root.$emit('modal-msg-open-change-user-status', data.config)
			})

			this.$root.$on('modal-msg-change-inactives-status-response', () => {
				this.$root.$emit('users-inactives-search')
			})
		},

		beforeDestroy() {
			this.$root.$off('users-inactives-add')
			this.$root.$off('users-inactives-search')
			this.$root.$off('filter-list-inactives-users')
			this.$root.$off('clear-list-inactives-users')
			this.$root.$off('open-change-inactives-status-modal')
			this.$root.$off('modal-msg-change-inactives-status-response')
			this.$root.$off('modal-msg-close-mass-change-user-status', this.clearSelect())
		},

		methods: {
			handleCheckedItens(itens){
				this.checkedItens = itens.length; // Conta os itens
				this.ids = itens.map(item => item.id); // Extrai os IDs usando map
			},
			handleMassAction(){
				if(this.value){
					this.modalButtonText = this.selectMassAction.find(action => action.value === this.value)?.label || '';
					
					this.modalMessageContent()

					this.$root.$emit('modal-msg-open-mass-change-user-status');
				}
				return;
			},
			async bulkStatusChangeAction(){
				this.loadingBulkChange = true;
				this.success = false;
				this.cancelButtonHandle = false;
				
                const usersIds = this.ids;
                const newStatus = this.selectMassAction.find(action => action.value === this.value)?.value || '';
                const bulkStatusChangePayload = {
					users: usersIds,
                    status: newStatus
                }
				await user.bulkStatusChange(bulkStatusChangePayload)
				.then((response) => {
					if(response.status === 'success'){
						setTimeout(() =>{
							this.success = true;
							this.loadingBulkChange = false;
							this.cancelButtonHandle = false;
							this.$root.$emit('users-inactives-search')
							}, 500)
						}
                    })
                    .catch((error) => {
						setTimeout(() => { // Pequeno atraso para garantir que o loading seja visível
							this.modalErrorText = 'Alguns usuários podem não ter sido processados.';
							this.colorSquare = 'danger'
							this.responseError = true
							this.success = false;
							this.loadingBulkChange = false;
							this.cancelButtonHandle = false;
						}, 500)
                    })
				},

			modalMessageContent(){
				const action = this.selectMassAction.find(action => action.value === this.value)?.value

				this.userCountText = this.checkedItens === 1 ? 'usuário' : 'usuários';
				
				if(action === 'active'){
					this.modalTitle = "Desbloquear múltiplos usuários"
					this.modalAction = "desbloquear";
					this.modalActionExecuted = 'desbloqueados'
					this.modalText = `${this.checkedItens} ${this.userCountText}`
				}
			},
			clearSelect(){
				this.value = null;
			},
			closeModal(){
				this.$root.$emit('modal-msg-close-mass-change-user-status');
				setTimeout(() => {
					this.loadingBulkChange = false;
					this.success = false;
					this.cancelButtonHandle = true;
					this.colorSquare = 'primary'
					this.responseError = false
				}, 500);
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
